import * as React from "react"

function SvgCheck(props) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6A6 6 0 110 6a6 6 0 0112 0zM9.023 3.728a.562.562 0 00-.81.016L5.607 7.063l-1.57-1.57a.563.563 0 00-.795.794l1.985 1.986a.563.563 0 00.809-.015L9.03 4.514a.563.563 0 00-.008-.787z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgCheck
